"use client";
import * as React from "react";
const SvgFavoriteBorderSharp = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 16", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M11.6.5c-1.4 0-2.73.66-3.6 1.7A4.8 4.8 0 0 0 4.4.5 4.4 4.4 0 0 0 0 5c0 3.09 2.72 5.6 6.84 9.43L8 15.5l1.16-1.08C13.28 10.6 16 8.1 16 5A4.4 4.4 0 0 0 11.6.5M8.08 13.21 8 13.3l-.08-.08C4.12 9.7 1.6 7.36 1.6 5c0-1.64 1.2-2.86 2.8-2.86 1.23 0 2.43.8 2.86 1.92h1.5a3.1 3.1 0 0 1 2.84-1.93c1.6 0 2.8 1.23 2.8 2.87 0 2.36-2.51 4.69-6.32 8.21" }));
export {
  SvgFavoriteBorderSharp as default
};
